module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1272.8c8ff849.png";